var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.984 4.254C45.514 8.59 48.574 14.154 50 21c.529 7.802-.772 14.545-5.688 20.813-5.101 5.483-11.645 7.938-19 8.437-7.299-.136-13.46-2.528-18.808-7.504C1.7 37.168-.346 30.506-.211 23.211.488 15.887 3.412 9.813 9 5c9.787-6.204 20.973-7.072 30.984-.746ZM23 14l1 3 3-1v-2h-4Zm1 7c-1.365 1.137-1.365 1.137-1.098 4.16l.035 3.902.028 3.91L23 36h4V22l-3-1Z",
    fill: "#566C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.79519b6aad12bc33bfb453c2d77498cf.svg";
export { ForwardRef as ReactComponent };